<div class="d-flex flex-column justify-content-start align-items-stretch h-100 w-100 my-3">

    <app-spinner [isLoading]="isLoadingData" [isFullScreen]="false"></app-spinner>

    <div *ngIf="!isLoadingData" class="container-fluid p-4">

        <p-message
            styleClass="w-100"
            *ngIf="loadingMessage.show"
            [severity]="loadingMessage.severity"
            [text]="loadingMessage.text">
        </p-message>

        <div *ngIf="discounts && maxDiscount">

            <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-4">

                <span class="text-primary-color fw-bolder">{{labels.discountSelectorLabel}}</span>

                <div class="bg-accent-lighter-color w-100 mb-1 p-2">
                    <span class="font-weight-bold mb-0">{{labels.discountMaxAlertLabel}} {{ maxDiscount }}%.</span>
                    <span class="font-weight-light mb-0">{{labels.discountDocsAlertLabel}}</span>
                </div>

                <app-discounts-selector
                    class="w-100"
                    [discounts]="discounts"
                    [maxDiscount]="maxDiscount"
                    [(selectedDiscountCodes)]="enrollment.discountCodes"
                    [(selectedTotalDiscount)]="enrollment.totalDiscount">
                </app-discounts-selector>

            </div>

        </div>

    </div>

</div>
